module.exports = __webpack_public_path__ + "img/dataV_B.2b0e2096.png";